<template>
  <div class="header2 flexaj">
    <div class="container flexsb">
      <img
        class="pointer-underline"
        src="@/assets/images/home/home-logo3.png"
        height="56"
        alt
        @click="toHome"
      />
      <div class="list flexa">
        <a
          class="item"
          :class="nowIndex==1?'active':''"
          href="http://www.globalcash.cn/v4"
        >{{$t("header2.homePage")}}</a>
        <a
          href="http://www.globalcash.cn/v4/apply"
          class="item"
        >{{$t("header2.getMyCard")}}</a>
        <a
          class="item"
          :class="nowIndex==3?'active':''"
          href="http://www.globalcash.cn/v4/information"
        >{{$t("header2.latestActivity")}}</a>
        <a
          class="item"
          :class="nowIndex==4?'active':''"
          href="http://www.globalcash.cn/v4/discount"
        >{{$t("header2.discount")}}</a>
        <a
          class="item"
          :class="nowIndex==5?'active':''"
          href="http://www.globalcash.cn/v4/help-center"
        >{{$t("header2.helpCenter")}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowIndex: 1
    };
  },
  methods: {
    toHome() {
      this.$router.push({ name: "home" });
    }
  },
  watch: {
    $route(to) {
      if (to.path == "/") {
        this.nowIndex = 1;
      }
      if (to.path == "/help-center") {
        this.nowIndex = 5;
      }
      if (
        to.path.indexOf("/information") === 0 ||
        to.path.indexOf("/infor-detail") === 0
      ) {
        this.nowIndex = 3;
      }
      if (to.path.indexOf("/discount") === 0) {
        this.nowIndex = 4;
      }
    }
  },
  mounted() {
    if (this.$route.name == "discount") {
      this.nowIndex = 4;
    }
    if (this.$route.name == "information") {
      this.nowIndex = 3;
    }
    if (this.$route.name == "help-center") {
      this.nowIndex = 5;
    }
    if (this.$route.name == "home") {
      this.nowIndex = 1;
    }
  }
};
</script>
<style lang="scss" scoped>
.header2 {
  height: 92px;
  border-bottom: 1px solid #ccc;
  .container {
    width: 960px;
    .list {
      .item {
        display: inline-flex;
        align-items: center;
        /* height: 100%;
        line-height: 100%; */
        /* vertical-align: middle; */
        padding: 0px 25px;
        font-size: 16px;
        text-decoration: none;
        /* flex-wrap: nowrap; */
      }
      .item:hover {
        color: #ff9600;
        cursor: pointer;
      }
      .active {
        color: #ff9600;
      }
    }
  }
}
</style>
